import Handlebars from '@sparta.global.vendors/handlebars';
import { button } from '@sparta.global.helpers/button-helper/dist/es5.js';
import { requiredAttrsCheck, extend, removeReservedAttrs, combineAttrs, buildAttrsString } from '@sparta.global.helpers/utils-helper/dist/es5.js';

// The module to be exported
function radioButton(data) {
  var requiredAttrs = ['id'];
  var reservedAttrs = ['type', 'name', 'data-help-link', 'data-help-head', 'data-help-body'];
  var combinableAttrs = {
    class: 'spa-input-option spa-input-option--radio',
    value: ''
  };
  var sRadioButtonGroup = '';
  var dataHelpToggle = data.helpToggle ? data.helpToggle : data.label;
  var dataADAHiddenLabel = data.adaHiddenLabel ? data.adaHiddenLabel : false;
  for (var i = 0, len = data.radioButtons.length; i < len; i += 1) {
    var _radioButton = data.radioButtons[i];
    var oAttributeGroup = {};
    var helpToggle = _radioButton.helpToggle ? _radioButton.helpToggle : _radioButton.label.text;
    if (!requiredAttrsCheck(_radioButton.radioButton.attrs, requiredAttrs).pass) {
      throw new Error("You are missing the required attribute ".concat(requiredAttrsCheck(_radioButton.radioButton.attrs, requiredAttrs).missingField));
    }
    extend({}, oAttributeGroup, _radioButton.radioButton.attrs);
    removeReservedAttrs(oAttributeGroup, reservedAttrs);
    combineAttrs(oAttributeGroup, combinableAttrs);
    var attrsStr = buildAttrsString(oAttributeGroup);
    var sRadioOptionWrapper = "<div class='spa-input-options-wrapper".concat(_radioButton.radioButton.attrs['data-help-body'] ? ' has-help' : '', "'").concat(_radioButton.radioButton.conditionalContent ? " data-option-has-conditional-content data-conditional-content='".concat(_radioButton.radioButton.conditionalContent, "'") : '', " >");
    var sRadioOption = "<input type='radio' ".concat(attrsStr).concat(data.vueOptionsStr || '', " name='").concat(data.name, "'").concat(_radioButton.disabled || data.disabled ? " disabled aria-disabled='true'" : '', " />") + '<span class=\'spa-input-check\'>&#160;</span>';
    var sRadioOptionLabel = "".concat("<label class='spa-input-option-label'" + " for='").concat(_radioButton.radioButton.attrs.id, "'>").concat(_radioButton.label.text, "<span class='ada-hidden'>").concat(_radioButton.label.adaText ? _radioButton.label.adaText : '', "</span>") + '</label>';
    var sRadioConditionalContent = '';
    if (_radioButton.radioButton.attrs['data-help-body']) {
      // Add a help pop-up trigger, either a question mark or some link text.
      var _triggerText = _radioButton.radioButton.attrs['data-help-link'] || '';
      var triggerClass = _triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
      var sRadioOptionHelpTrigger = button({
        content: _triggerText || '&#160;',
        classes: "".concat(triggerClass, " spa-btn--link"),
        attributes: {
          id: "help-open-".concat(_radioButton.radioButton.attrs.id),
          "aria-label": helpToggle
        }
      });
      var sRadioOptionHelpContainer = "<div class='input-help' id='helpLayer_".concat(_radioButton.radioButton.attrs.id, "' role='tooltip' aria-hidden='true'>");
      var sRadioOptionHelpClose = button({
        content: '&#160;',
        classes: "close-trigger svg-button",
        attributes: {
          id: "help-close-".concat(_radioButton.radioButton.attrs.id),
          "aria-label": helpToggle
        }
      });
      var sRadioOptionHelpBody = "<div class='body'>".concat(_radioButton.radioButton.attrs['data-help-body'], "</div>");
      if (_radioButton.radioButton.attrs['data-help-head']) {
        // New HELIX Requirement
        // --------------------------------
        // sRadioOptionHelpBody = "<div class='head' data-font='cnx-bold'>" +
        sRadioOptionHelpBody = "<div class='head'>".concat(_radioButton.radioButton.attrs['data-help-head'], "</div>").concat(sRadioOptionHelpBody);
        // --------------------------------
      }
      if (_radioButton.radioButton.conditionalContent) {
        sRadioConditionalContent = "<div id='".concat(_radioButton.radioButton.attrs.id, "_conditional-content' class='spa-input-option-conditional-content' data-option-conditional-content></div>");
      }
      sRadioOptionHelpContainer += "".concat(sRadioOptionHelpClose + sRadioOptionHelpBody, "</div>");
      sRadioOptionWrapper += "".concat(sRadioOption + sRadioOptionLabel + sRadioOptionHelpTrigger + sRadioOptionHelpContainer + sRadioConditionalContent, "</div>");
    } else {
      sRadioOptionWrapper += "".concat(sRadioOption + sRadioOptionLabel + sRadioConditionalContent, "</div>");
    }
    sRadioButtonGroup += sRadioOptionWrapper;
  }
  var triggerText = data['data-help-link'] || '';
  var helpText = data['data-help-body'] || '';
  var vBind = data['data-v-bind'] ? "data-v-bind=".concat(data['data-v-bind']) : '';
  var inlineTriggerClass = '';
  var clearFixClassName = '';
  if (helpText && !triggerText) {
    inlineTriggerClass = ' inline-legend-icon';
    clearFixClassName = ' clearfix';
  }
  var sRadioGroupContainer = "<div class='spa-input spa-input-options spa-input--".concat(data.skin ? data.skin : 'sparta2').concat(data.darkBackground ? ' spa-input-options--inverse' : '').concat(data.containerClasses ? " ".concat(data.containerClasses.join(' ')) : '').concat(data['data-help-body'] ? ' has-help' : '', "'>");
  var sRadioGroupFieldset = "<fieldset class=\"spa-fieldset".concat(clearFixClassName, "\" aria-describedby=\"").concat(data.id, "_errorMessage ").concat(data.id, "-hint-text\" id=\"").concat(data.id, "\" ").concat(data.validationRules ? " data-validation-rules='".concat(JSON.stringify(data.validationRules).replace(/'/g, '&#39;'), "'") : '').concat(data.required ? " required aria-required='true'".concat(typeof data.required === 'string' ? " data-required-error-message=\"".concat(data.required, "\"") : '') : '', ">");
  var inputLabelRequiredSpan = function inputLabelRequiredSpan(required) {
    if (required) {
      return '<span class="spa-input-label--asterisk">&nbsp;*</span>';
    }
    return '';

    /* Save me in case this gets used again.
    const optionalText = '<span class="spa-input-label__optional-text">optional</span>';
    return `
      <span class="spa-input-label--required">
        <span aria-hidden="true">(</span>${optionalText}<span aria-hidden="true">)</span>
      </span>
    `;
    */
  };
  var sRadioGroupFieldsetLabel = "<legend class=\"spa-fieldset-label".concat(inlineTriggerClass, "\" for=\"").concat(data.id, "\" aria-hidden=\"").concat(dataADAHiddenLabel, "\">").concat(data.label).concat(data.required ? inputLabelRequiredSpan(true, data.asterisk) : '', "<span class='ada-hidden'>").concat(data.adaText ? data.adaText : '', "</span>") + '</legend>';
  var sRadioGroupWrapper = "<div ".concat(vBind, " class='spa-input-options-list spa-input-options-list--").concat(data.direction ? data.direction : 'vertical', "'>").concat(sRadioButtonGroup).concat(data.direction ? "<div class='horizontal-clear'></div>" : '', "</div>");
  var sRadioGroupHint = "<p id='".concat(data.id, "-hint-text' class='spa-input-options-hint'>").concat(data.hintText ? data.hintText : '', "</p>");
  var sRadioGroupError = "<div id='".concat(data.id, "_errorMessage' class='spa-input-error-message spa-icon--error' aria-hidden='true'></div>");
  if (data['data-help-body']) {
    // Add a help pop-up trigger, either a question mark or some link text.
    var setTriggerText = data['data-help-link'] || '';
    var _triggerClass = setTriggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
    var wrapperClass = setTriggerText ? '' : 'class="flex-wrapper"';
    var sRadioGroupHelpTrigger = button({
      content: setTriggerText || '&#160;',
      classes: "".concat(_triggerClass, " spa-btn--link"),
      attributes: {
        id: "help-open-".concat(data.id),
        "aria-label": dataHelpToggle
      }
    });
    var sRadioGroupHelpContainer = "<div class='input-help' id='helpLayer_".concat(data.id, "' role='tooltip' aria-hidden='true' >");
    var sRadioGroupHelpClose = button({
      content: '&#160;',
      classes: "close-trigger svg-button",
      attributes: {
        id: "help-close-".concat(data.id),
        "aria-label": dataHelpToggle
      }
    });
    var sRadioGroupHelpBody = "<div class='body'>".concat(data['data-help-body'], "</div>");
    if (data['data-help-head']) {
      sRadioGroupHelpBody = "<div class='head' data-font='cnx-bold'>".concat(data['data-help-head'], "</div>").concat(sRadioGroupHelpBody);
    }
    sRadioGroupHelpContainer += "".concat(sRadioGroupHelpClose + sRadioGroupHelpBody, "</div>");
    sRadioGroupFieldset += "<div ".concat(wrapperClass, ">").concat(sRadioGroupFieldsetLabel).concat(sRadioGroupHelpTrigger, "</div>").concat(sRadioGroupHelpContainer).concat(sRadioGroupWrapper).concat(sRadioGroupHint).concat(sRadioGroupError, "</fieldset>");
  } else {
    sRadioGroupFieldset += "".concat(sRadioGroupFieldsetLabel + sRadioGroupWrapper + sRadioGroupHint + sRadioGroupError, "</fieldset>");
  }
  sRadioGroupContainer += "".concat(sRadioGroupFieldset, "</div>");
  return new Handlebars.SafeString(sRadioGroupContainer);
}
export { radioButton };